// API configuration that works in both development and production
export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '' // Use same domain in production
  : 'http://localhost:3001'; // Local development server

// Use .php extension only if specifically configured for cPanel, otherwise use default
const getEndpoint = (name) => {
  // Check if we are running on Vercel
  const isVercel =
    (typeof window !== 'undefined' && (
      window.location.hostname.includes('vercel.app') ||
      window.location.hostname.includes('vercel.com') ||
      window.location.hostname.includes('.app') // Custom Vercel domains
    )) ||
    process.env.REACT_APP_IS_VERCEL === 'true' ||
    process.env.REACT_APP_VERCEL === 'true' ||
    process.env.VERCEL === '1'; // Vercel sets this env var

  // Only use .php extension for cPanel deployments (when in production but NOT on Vercel)
  // For Vercel and development, use no extension (serverless functions)
  const extension = (process.env.NODE_ENV === 'production' && !isVercel) ? '.php' : '';
  return `${API_BASE_URL}/api/${name}${extension}`;
};

export const API_ENDPOINTS = {
  SEND_LEAD_EMAIL: getEndpoint('send-lead-email'),
  SEND_WELCOME_EMAIL: getEndpoint('send-welcome-email'),
  SEND_USER_MOVERS_ASSIGNED: getEndpoint('send-user-movers-assigned'),
  SEND_MOVER_NEW_LEAD: getEndpoint('send-mover-new-lead'),
  SEND_CONTACT_FORM: getEndpoint('send-contact-form'),
};
